import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from '@reduxjs/toolkit/query/react'

const baseUrl = `${baseURL}/auth/`

export const authApiService = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({
        currentUser: builder.query({ query: () => 'me' }),
        login: builder.mutation({
            query: (payload) => ({
                url: 'login',
                method: 'POST',
                body: { email: payload.email.trim().toLowerCase(), password: payload.password }
            })
        }),
        deactivateAccount: builder.mutation({
            query: ({ password }) => {
            
              return {
                url: 'deactivate',
                method: 'POST',
                body: { password },
              };
            },
          }),
          
          
        forgetPassword: builder.mutation({
            query: (payload) => ({
                url: 'forgot-password',
                method: 'POST',
                body: payload
            })
        }),
        verifyOtp: builder.mutation({
            query: (payload) => ({
                url: 'verify-otp',
                method: 'POST',
                body: payload
            })
        }),
        resetPassword: builder.mutation({
            query: (payload) => ({
                url: 'reset-password',
                method: 'POST',
                body: payload
            })
        }),
        sendVerificationToken: builder.mutation({
            query: (payload) => ({
                url: 'resend-verification',
                method: 'POST',
                body: payload
            })
        }),
        verifyToken: builder.mutation({
            query: (payload) => ({
                url: 'verify-user',
                method: 'POST',
                body: payload
            })
        }),
        verifyEmailToken: builder.mutation({
            query: (token) => ({
                url: `verify-email/${token}`,
                method: 'GET',
            })
        }),
        signup: builder.mutation({
            query: (payload) => ({
                url: 'signup',
                method: 'POST',
                body: payload
            })
        }),
    })
})

export const {
    useCurrentUserQuery,
    useLoginMutation,
    useForgetPasswordMutation,
    useVerifyOtpMutation,
    useResetPasswordMutation,
    useSendVerificationTokenMutation,
    useVerifyTokenMutation,
    useVerifyEmailTokenMutation,
    useDeactivateAccountMutation,
    useSignupMutation
} = authApiService
